import React from 'react'
import { useStateValue } from '@State'
import { Form } from 'react-bootstrap'

const NewPaymentFormInputs = () => {
  const [currentState, dispatch] = useStateValue()
  return (
    <React.Fragment>
      <Form.Group>
        <Form.Label>Description</Form.Label>
        <Form.Control
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewPaymentDescription',
              newPaymentDescription: e.target.value,
            })
          }
          value={currentState.newPaymentDescription}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Amount</Form.Label>
        <Form.Control
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewPaymentAmount',
              newPaymentAmount: e.target.value,
            })
          }
          value={currentState.newPaymentAmount}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Stripe Transaction ID</Form.Label>
        <Form.Control
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewPaymentTransactionID',
              newPaymentTransactionID: e.target.value,
            })
          }
          value={currentState.newPaymentTransactionID}
        />
        <Form.Text>
          If this was a credit card transaction run via Stripe, enter the Stripe
          Transaction ID here.
        </Form.Text>
      </Form.Group>
      <Form.Group>
        <Form.Label>Source</Form.Label>
        <Form.Control
          as="select"
          onChange={e =>
            dispatch({ type: 'updateNewSource', newSource: e.target.value })
          }
          value={currentState.newSource}
        >
          <option value="">Select Option</option>
          <option value="ACH">ACH</option>
          <option value="Credit Card">Credit Card</option>
          <option value="Check">Check</option>
          <option value="Paypal">Paypal</option>
          <option value="Wire">Wire</option>
          <option value="Other">Other</option>
        </Form.Control>
        <Form.Text>Optional</Form.Text>
      </Form.Group>
      <Form.Group>
        <Form.Label>Invoice Number</Form.Label>
        <Form.Control
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewInvoiceNumber',
              newInvoiceNumber: e.target.value,
            })
          }
          value={currentState.newInvoiceNumber}
        />
        <Form.Text>Optional</Form.Text>
      </Form.Group>
      <Form.Group>
        <Form.Label>Course Number</Form.Label>
        <Form.Control
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewPaymentCoursenum',
              newPaymentCoursenum: e.target.value,
            })
          }
          value={currentState.newPaymentCoursenum}
        />
      </Form.Group>
    </React.Fragment>
  )
}

export default NewPaymentFormInputs
